module.exports = __webpack_public_path__ + "img/ic-back-arrow-gray.1f71f20b.svg";